import { BoardTypeFirestorePersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const BoardTypePersistenceProvider = createStaticContextProvider(
  BoardTypeFirestorePersistenceContext,
  lazyValue(() =>
    import("./board-type-persistence").then(
      (module) => module.boardTypePersistence,
    ),
  ),
);
